import { useNavigate, useLocation } from 'react-router-dom';
import '../../css/shared/TabBar.css';
import { useLang } from '../../i18n';

const ICON_FILE = {
  menu:    'tabbar-menu',
  sports:  'tabbar-sport',
  home:    'tabbar-home',
  explore: 'tabbar-explore',
};

function TabIcon({ name }) {
  return (
    <span className="tabbar-icon">
      <img src={`/img/${ICON_FILE[name]}.svg`} alt="" />
    </span>
  );
}

const TABS = [
  { id: 'menu',    labelKey: 'nav.menu',    path: '/menu' },
  { id: 'sports',  labelKey: 'nav.sports',  path: '/sports' },
  { id: 'home',    labelKey: 'nav.home',    path: '/' },
  { id: 'explore', labelKey: 'nav.explore', path: null },
];

export default function TabBar({ active, onMenu }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLang();

  const currentTab = active || TABS.find((tab) => tab.path && tab.path === location.pathname)?.id || 'home';

  const handleTab = (tab) => {
    if (tab.id === 'menu')    { onMenu?.(); return; }
    if (tab.id === 'explore') { window.dispatchEvent(new Event('openSearch')); return; }
    navigate(tab.path);
  };

  return (
    <nav className="tabbar">
      {TABS.map((tab) => (
        <button
          key={tab.id}
          className={'tabbar-item' + (currentTab === tab.id ? ' is-active' : '')}
          onClick={() => handleTab(tab)}
        >
          <TabIcon name={tab.id} />
          <span className="tabbar-label">{t(tab.labelKey)}</span>
        </button>
      ))}
    </nav>
  );
}
